export default "__VITE_ASSET__97e606d7__"